import React from "react";
import { withRouter } from "react-router-dom";

class BackButton extends React.Component {
	historyGoBack = () => {
		this.props.history.goBack();
	};

	render() {
		if (this.props.location.pathname === "/industry") {
			return ""; // Dont Show button on first screen
		}
		return (
			<div className="back" onClick={this.historyGoBack}>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="24"
					height="24"
					viewBox="0 0 24 24">
					<path fill="none" d="M0 0h24v24H0V0z" />
					<path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
				</svg>
				<span>Back</span>
			</div>
		);
	}
}

export default withRouter(BackButton);
